<template>
  <div>
    <section>
      <!-- Image Uploads and Display -->
      <h5>Images</h5>

      <div class="banner-section" v-if="loadStatus">
        <SkeletonLoader
          class="trending-element"
          height="174px"
          width="160px"
          v-for="(item, index) in 4"
          :key="'item' + index"
          :style="{ 'margin-right': '10px' }"
        />
      </div>

      <template v-else>
        <div class="banner-section">
          <div v-for="(image, index) in productImages" :key="index">
            <div
              class="banner-portrait"
              :class="creatingProductImages ? 'opacity-80' : ''"
            >
              <img
                class="banner-img"
                :src="
                  image.url
                    ? image.url
                    : '@/assets/trusted-health-patagonia-jacket.svg'
                "
                alt=""
              />
            </div>
            <div class="radio-holder">
              <div class="label-holder flex items-center">
                <label>
                  <input
                    name="product-image"
                    :id="'product-image-' + index"
                    :value="'product-image-' + index"
                    type="radio"
                    :checked="defaultECommerceImageId == image.id"
                    @change="setSelectedImageId(image.id)"
                    customStyles="position: relative; bottom: 2px; font-weight: bold; font-size: 0.813rem"
                  />
                  <span></span>
                </label>
                <div class="flex items-center">
                  <label :for="'product-image-' + index" class="label inter">
                    Default
                  </label>
                </div>
              </div>
              <div
                class="delete-icon-holder pointer"
                @click="onDeleteAttatchment(image.id)"
              >
                <img src="@/assets/trash.svg" alt="" />
              </div>
            </div>
          </div>

          <div v-if="!loadStatus">
            <div class="banner-portrait upload-holder">
              <input
                id="product-image"
                type="file"
                multiple
                @change="uploadImage"
                accept="image/png, image/jpeg"
              />

              <div class="allowed-files">
                <img src="@/assets/add_icon.svg" alt="" />
                <p class="add">Add image</p>
              </div>
            </div>
            <div class="radio-holder opacity-0">
              <radio-button
                label="Default"
                value="default-description"
                customStyles="position: relative; bottom: 2px; font-weight: bold; font-size: 0.813rem"
              />
            </div>
          </div>
        </div>
      </template>
    </section>

    <div class="banner-section" v-if="loadStatus || loadingSelectedVariants">
      <SkeletonLoader
        class="trending-element"
        height="174px"
        width="100%"
        :style="{ 'margin-right': '10px' }"
      />
    </div>
    <!-- Variants -->
    <section v-else>
      <h5>Variants</h5>

      <section>
        <template>
          <div
            class="variant-section"
            v-for="(variant, index) in [...productVariants]"
            :key="variant.id"
          >
            <div class="variant-selector-holder">
              <div class="variant-color-container">
                <h6 class="">
                  {{
                    storeProductVariants[index]
                      ? storeProductVariants[index].attributes.displayName
                      : ''
                  }}
                </h6>
              </div>

              <div>
                <h6>
                  Select image(s)
                  <small
                    >Images selected for a color will apply to all/any size
                    variants available.
                  </small>
                </h6>

                <div class="banner-section" v-if="loadStatus">
                  <SkeletonLoader
                    class="trending-element"
                    height="71px"
                    width="70px"
                    v-for="(item, index) in 4"
                    :key="'item' + index"
                    :style="{ 'margin-right': '10px' }"
                  />
                </div>

                <ul class="variants-holder" v-else>
                  <li
                    class="variant-portrait"
                    v-for="(image, index) in productImages"
                    :key="image.id"
                  >
                    <input
                      type="radio"
                      :id="variant.id"
                      :name="image.id"
                      class="hidden peer"
                      required=""
                    />
                    <label
                      @click="
                        selectVariant($event, variant.id, image.id, variant)
                      "
                      :for="variant.id"
                      :id="image.id"
                      class="inline-flex justify-between items-center"
                      :class="{
                        selected: imageisSelected(variant.id, image.id, index)
                      }"
                    >
                      <div class="">
                        <img
                          class="variant-img"
                          :src="
                            image.url
                              ? image.url
                              : '@/assets/variant_product.svg'
                          "
                        />
                      </div>
                    </label>
                  </li>
                </ul>
                <div class="view-options" v-if="variant.images.length > 6">
                  <span @click="toggleVariantView">View more</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </section>
    </section>
  </div>
</template>

<script>
import SkeletonLoader from '@/components/Universal/Skeleton'
import { mapState } from 'vuex'
let bodyFormData = new FormData()

export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  components: {
    RadioButton: () => import('@/components/Universal/RadioButton.vue'),
    SkeletonLoader
  },

  data() {
    return {
      loadingSelectedVariants: true,
      selectedVariants: [],
      selectedProductVariants: []
    }
  },

  async created() {
    await this.$store.dispatch('ecommerce/getProductImages', this.product)
    await this.$store.dispatch(
      'ecommerce/getStoreProductVariants',
      this.product.id
    )
    this.loadingSelectedVariants = false
  },

  computed: {
    loadBundleDetails: state => state.product.loadBundleDetails,

    loadStatus() {
      return this.loadingProductImages
    },
    isChecked() {
      return true
    },
    ...mapState({
      showModal: state => state.modal.showModal,
      productAttributes: state => state.ecommerce.productAttributes,
      productImages: state => state.ecommerce.productAttributes.images,
      // productVariants: state => state.ecommerce.productAttributes.variants,
      storeProductVariants: state => state.ecommerce.productVariants,
      defaultECommerceImageId: state =>
        state.ecommerce.productAttributes.defaultECommerceImageId,
      creatingProductImages: state => state.ecommerce.creatingProductImages,
      loadingProductImages: state => state.ecommerce.loadingProductImages
    }),

    productVariants() {
      return this.storeProductVariants.map(variant => variant.attributes.images)
    }
  },

  beforeMount() {},
  methods: {
    imageisSelected(variant_id, product_image_id) {
      let variant = this.productVariants.find(
        variant => variant.id == variant_id
      )
      if (variant && variant.images.length) {
        return variant.images[0].id === product_image_id
      }
      return false
    },

    async uploadImage(e) {
      const files = e.target.files

      if (files.length) {
        // Push newly added files to formData
        for (let i = 0; i < files.length; i++) {
          let file = files.item(i)
          bodyFormData.append('product[ecommerce_images][]', file)
        }

        // make request
        await this.$store.dispatch('ecommerce/createProductImages', {
          product_id: this.product.id,
          formData: bodyFormData
        })

        bodyFormData = new FormData()
      }
    },

    toggleVariantView(e) {
      if (
        e.target.parentNode.parentElement.children[1].classList.contains(
          'active'
        )
      ) {
        e.target.parentNode.parentElement.children[1].classList.remove('active')
        e.target.innerText = 'View more'
      } else {
        e.target.parentNode.parentElement.children[1].classList.add('active')
        e.target.innerText = 'View less'
      }
    },

    async onDeleteAttatchment(id) {
      await this.$store.dispatch('ecommerce/deleteProductImage', {
        product_id: this.product.id,
        image_id: id
      })
    },

    setSelectedImageId(id) {
      this.$store.commit('ecommerce/SET_SELECTED_IMAGE_ID', id)
    },

    selectVariant(e, variant_id, image_id) {
      let parent_element = e.target.parentElement.parentElement
      for (
        let index = 0;
        index < parent_element.parentElement.parentElement.children.length;
        index++
      ) {
        let element = parent_element.parentElement.parentElement

        for (let i = 0; i < element.children[index].children.length; i++) {
          const label = element.children[index].children[i]
          if (label.tagName == 'LABEL' && label.id == image_id) {
            label.classList.add('selected')

            this.$store.commit('ecommerce/SET_SELECTED_PRODUCT_VARIANTS', {
              id: variant_id,
              image_ids: [image_id]
            })
          } else {
            label.classList.remove('selected')
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';
@import '@/scss/vue-tag-input.scss';

.banner-section {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 2rem;
  margin: 1rem 0;

  .radio-holder {
    display: flex;
    justify-content: space-between;
    padding: 1rem 0rem;
    align-items: center;

    .label-holder {
      position: relative;
      top: -0.2rem;
    }

    .flex {
      display: flex;
    }

    .items-center {
      align-items: center;
    }

    label {
      position: relative;
      cursor: pointer;
      margin-top: 1px;
    }

    span {
      width: 1.125rem;
      height: 1.125rem;
      border-radius: 50%;
      border: 1px solid $onyx;
      display: inline-block;
      background: inherit;
      transition: all linear 0.3s;
      display: flex;
    }

    span.disabled {
      border: 1px solid #9b9b9b;
    }

    span:after {
      content: '';
      position: absolute;
      top: 4.5px;
      left: 4.5px;
      border: 1px solid $onyx;
      height: 8px;
      width: 8px;
      background: $onyx;
      border-radius: 50%;
      transform: rotate(45deg);
      visibility: hidden;
    }

    input {
      display: none;
    }

    input:checked ~ span {
      background: #25282a;
      border: 2px solid #25282a;
    }

    input:checked ~ span:after {
      visibility: visible;
    }

    .label {
      font-size: 0.775rem;
      color: #25282a;
      margin-left: 0.5rem;
      cursor: pointer;
    }

    .label.padded {
      position: relative;
      bottom: 2px;
    }

    .disabled {
      /* opacity: 0.6; */
      color: #9b9b9b;
      cursor: not-allowed;
    }
  }

  .delete-icon-holder img {
    position: relative;
    top: -0.3rem;
  }
}

.banner-portrait {
  width: 188px;
  height: 197px;
  border: 1px solid #232220;
  background: white;
  padding: 0.75rem;

  &.default {
    border: 1px solid #24292c;
  }

  .banner-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    margin: 0 auto;
  }

  input[type='radio'] + label {
    border: 1px solid #9b9b9b;
  }

  input[type='radio']:checked + label {
    border: 2px solid #24292c;
  }
}

.upload-holder {
  border: 1px dashed #9b9b9b;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: white;
  box-sizing: border-box;
  // background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%239B9B9BFF' stroke-width='2' stroke-dasharray='5%2c8' stroke-dashoffset='-3' stroke-linecap='square'/%3e%3c/svg%3e");

  input[type='file'] {
    cursor: pointer;
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .allowed-files {
    display: flex;
    gap: 0.5rem;

    p {
      color: #232220;
      font-size: 0.75rem;
      text-transform: uppercase;
    }
  }

  label {
    display: block;
    cursor: pointer;

    &.active {
      border: 2px solid #24292c !important;
    }

    div {
      display: flex;
      align-items: center;
    }
  }
}

// Variants
.variant-section {
  background: inherit;
  margin: 0.5rem 0 1rem 0;
  padding: 1rem;
  border: 1px solid $onyx;

  .variant-label {
    font-size: 0.813rem;
    color: $main-6;
    font-weight: bold;
  }

  .variant-selector-holder {
    display: grid;
    grid-gap: 3rem;
    grid-template-columns: 190px 1fr;
    margin: 1rem 0;
  }

  .variant-color-container {
    display: flex;
    gap: 1.5rem;
    align-items: center;
    height: max-content;
  }

  .variant-color-holder {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    height: max-content;
  }

  .variant-color {
    width: 20px;
    height: 20px;
    background-color: #000;
  }

  .variant-text {
    color: $main-6;
    font-weight: 500;
    font-size: 13px;
  }

  .variant-color2 {
    width: 20px;
    height: 20px;
    background-color: #6f00f6;
  }

  small {
    color: $onyx;
    font-size: 0.75rem;
    font-weight: 400;
    margin-left: 0.25rem;
  }

  .view-options {
    span {
      text-decoration: underline;
      font-size: 12px;
      font-weight: bold;
      display: block;
      cursor: pointer;
      color: #24292c;

      &.hidden {
        display: none;
      }
    }
  }
}

.variants-holder {
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 1rem;
  margin: 0.8rem 0;
  max-height: 75px;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;

  &.active {
    max-height: max-content;
  }
}

.variant-portrait {
  width: 70px;
  height: 71px;
  cursor: pointer;
  overflow: hidden;

  .variant-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    margin: 0 auto;
  }

  label {
    height: 100%;
    width: 100%;
    cursor: pointer;

    &.active {
      border: 2px solid #24292c !important;
    }

    &.selected {
      border: 2px solid #24292c !important;
      background-color: transparent !important;
    }

    div {
      background: white;
      width: 100%;
      padding: 0.5rem;
    }
  }

  input[type='radio'] + label {
    border: 1px solid #9b9b9b;
    overflow: hidden;
  }

  input.selectedVariant + label {
    border: 2px solid #24292c;
  }
}

.items-center {
  align-items: center;
}

.font-bold,
h6 {
  font-weight: 600;
  font-size: 0.875rem;
  font-family: $inter;
}

h5 {
  font-family: $inter;
  font-weight: bold;
  font-size: 1rem;
  padding-bottom: 0.25rem;
}

.pointer {
  cursor: pointer;
}

.opacity-80 {
  opacity: 0.5;
  animation: blink 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

@keyframes blink {
  from {
    opacity: 0.2;
  }

  to {
    opacity: 0.7;
  }
}

@media (max-width: 768px) {
  .banner-section {
    align-items: flex-start;

    .banner-portrait {
      width: 85px;
      height: 94px;
    }
  }

  .banner-section .radio-holder .label {
    display: none;
  }

  .variant-section {
    background: $main-7;
    margin: 2rem 0;
    padding: 1rem;

    .variant-selector-holder {
      grid-template-columns: 1fr;
    }
  }

  .upload-holder {
    padding: 0.4rem;

    .allowed-files {
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>
